export const VIEW_ACCESS = 'view';
export const ADDON_ACCESS = 'addon';
export const ADMIN_ACCESS = 'admin';
export const MASTER_ACCESS = 'master';

export default {
  VIEW_ACCESS,
  ADDON_ACCESS,
  ADMIN_ACCESS,
  MASTER_ACCESS,
};
